import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-sm border-b border-gray-100 shadow-sm" data-id="element-141">
      <div className="container mx-auto px-4 py-5 flex justify-between items-center" data-id="element-142">
        <div className="flex items-center" data-id="element-143">
          <span className="text-2xl tracking-tight flex items-center" data-id="element-144">
            <span className="font-bold text-gray-900" data-id="element-145">swedenmark</span>
            <span className="mx-0.5 text-[1.6rem] leading-none translate-y-[-1px] text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-red-500" data-id="element-146">
              &bull;
            </span>
            <span className="font-semibold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-red-500" data-id="element-147">
              studio
            </span>
          </span>
        </div>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-8" data-id="element-148">
          <a href="#about" className="text-gray-600 hover:text-blue-600 transition-colors" data-id="element-149">
            About
          </a>
          <a href="#services" className="text-gray-600 hover:text-blue-600 transition-colors" data-id="element-150">
            Services
          </a>
          <a href="#contact" className="text-gray-600 hover:text-blue-600 transition-colors" data-id="element-151">
            Contact
          </a>
        </nav>
        {/* Mobile Menu Button */}
        <button className="md:hidden text-gray-600" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-152">
          {isMenuOpen ? <XIcon size={24} data-id="element-153" /> : <MenuIcon size={24} data-id="element-154" />}
        </button>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden bg-white border-t border-gray-100 py-4" data-id="element-155">
          <div className="container mx-auto px-4 flex flex-col space-y-4" data-id="element-156">
            <a href="#about" className="text-gray-600 hover:text-blue-600 transition-colors py-2" onClick={() => setIsMenuOpen(false)} data-id="element-157">
              About
            </a>
            <a href="#services" className="text-gray-600 hover:text-blue-600 transition-colors py-2" onClick={() => setIsMenuOpen(false)} data-id="element-158">
              Services
            </a>
            <a href="#contact" className="text-gray-600 hover:text-blue-600 transition-colors py-2" onClick={() => setIsMenuOpen(false)} data-id="element-159">
              Contact
            </a>
          </div>
        </div>}
    </header>;
}